<app-header></app-header>
<ion-content
  data-cy="manage-users-content"
  class="gray-content-bg"
  scroll-y="false"
>
  <div
    class="scroll-container"
    data-cy="scroll-container"
    cdkVirtualScrollingElement
  >
    <!-- Page Header -->
    <div
      data-cy="manage-users-header"
      class="manage-users-header"
      [class.touch]="(platformService?.isTouchExperience$ | async)"
    >
      <ion-grid
        [fixed]="true"
        [class.touch]="(platformService?.isTouchExperience$ | async)"
      >
        <!-- Breadcrumbs -->
        <ion-row
          *ngIf="(platformService?.isTouchExperience$ | async) === false"
          data-cy="manage-users-breadcrumbs-row"
          class="manage-users-breadcrumbs"
        >
          <ion-col data-cy="manage-users-breadcrumbs-column" size="12">
            <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
          </ion-col>
        </ion-row>
        <!-- Page Title -->
        <ion-row data-cy="manage-users-page-title-row">
          <ion-col data-cy="manage-users-page-title-row" size="12">
            <h2
              data-cy="manage-users-page-title-text"
              class="manage-users-title"
              [class.mobile-title]="platformService?.platformType === platformService?.platformEnum?.mobile"
            >
              {{ 'i18n.manageUsers.title' | translate | uppercase}}
            </h2>
          </ion-col>
        </ion-row>
        <ion-row data-cy="manage-users-page-subtitle" size="12">
          <div
            data-cy="manage-users-page-subtitle-text"
            class="manage-users-subtitle"
            [class.mobile-title]="platformService?.platformType === platformService?.platformEnum?.mobile"
          >
            {{ 'i18n.manageUsers.subtitle' | translate }}
          </div>
        </ion-row>
      </ion-grid>
    </div>
    <div>
      <ion-grid [fixed]="true">
        <ion-row
          *ngIf="inviteUsersFeatureFlag$ | async"
          class="ion-align-items-center"
        >
          <ion-col size="7.5">
            <ion-searchbar
              data-cy="ship-details-customer-searchbar"
              class="search with-invite-button"
              mode="md"
              placeholder="{{ 'i18n.manageUsers.searchByNameOrEmail' | translate }}"
              [(ngModel)]="searchKey"
              (ionInput)=" updateFilteredUserList($event) "
            ></ion-searchbar>
          </ion-col>
          <ion-col size="4.5" class="ion-text-right invite-user-column">
            <ion-button
              data-cy="invite-user-button"
              class="usf-fill-green-button"
              (click)="openInviteNewUserModal()"
            >
              {{ 'i18n.profilePage.inviteNewUser.button' | translate }}
            </ion-button>
          </ion-col>
        </ion-row>
        <!-- Use default layout if invite users feature flag is off -->
        <ion-row
          *ngIf="(inviteUsersFeatureFlag$ | async) === false"
          class="ion-align-items-center"
        >
          <ion-col size="12">
            <ion-searchbar
              data-cy="ship-details-customer-searchbar"
              class="search"
              mode="md"
              placeholder="{{ 'i18n.manageUsers.searchByNameOrEmail' | translate }}"
              [(ngModel)]="searchKey"
              (ionInput)=" updateFilteredUserList($event) "
            ></ion-searchbar>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div>
      <ion-grid [fixed]="true">
        <!-- START DESKTOP -->
        <ng-container
          *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
        >
          <div class="manage-users-list-section-desktop-container">
            <cdk-virtual-scroll-viewport
              class="virtual-scroll-viewport"
              [itemSize]="50"
              [minBufferPx]="400"
              [maxBufferPx]="800"
            >
              <app-sortable-section-desktop-tablet
                [sectionHeaders]="desktopHeaders"
                [selectedHeader]="selectedHeader"
                [hasSectionData]="true"
                [noDataText]="noUsersMessage | translate"
                (updateSortEventEmitter)="updateFilteredUserList($event)"
                [darkHeaders]="true"
              >
                <div *ngIf="(displayedUserList$ | async) as displayedUserList">
                  <div
                    *cdkVirtualFor="let user of displayedUserList; trackBy: trackByUserId"
                    class="sortable-section-data-row"
                  >
                    <app-manage-users-list-section-desktop
                      [user]="user"
                      [selectedHeader]="selectedHeader"
                      [currentUserId]="currentUserId"
                      (updateSort)="updateFilteredUserList($event)"
                      (openActionSheet)="openUserActionsHandler($event)"
                      (openExtendedView)="openUserExtendedView($event)"
                    >
                    </app-manage-users-list-section-desktop>
                  </div>
                </div>
              </app-sortable-section-desktop-tablet>

              <ng-container
                *ngIf="(customerUsers$ | async)?.length === 0 && (customerUsersCallComplete$ | async)"
              >
                <div class="empty-page-no-users-state-container">
                  <div class="empty-page-no-users-state-content">
                    <img
                      data-cy="'manage-users-empty-page-state'"
                      class="empty-page-image"
                      src="assets/images/chef-hat.svg"
                    />
                    <div class="no-users-message-container">
                      <span class="no-users-message">
                        {{ 'i18n.manageUsers.noUsers' | translate }}
                      </span>

                      <span>
                        {{ (currentCustomer$ | async)?.customerName }} ({{
                        (currentCustomer$ | async)?.customerNumber }})
                        <ng-container *ngIf="!!(currentDepartment$ | async)">
                          {{ (currentDepartment$ | async)?.departmentName }} ({{
                          (currentDepartment$ | async)?.departmentNumber }})
                        </ng-container>
                      </span>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="(customerUsers$ | async)?.length > 0 && (displayedUserList$ | async)?.length === 0"
              >
                <div class="empty-page-no-users-state-container">
                  <div class="empty-page-no-users-state-content">
                    <img
                      data-cy="'manage-users-empty-page-state'"
                      class="empty-page-image"
                      src="assets/images/chef-hat-with-search-icon.svg"
                    />
                    <div class="no-users-message-container">
                      <span class="no-users-message">
                        {{ ('i18n.manageUsers.noMatchesSearch' | translate: {
                        searchKey }) }}
                      </span>
                      <span>
                        {{ 'i18n.manageUsers.pleaseTryAgain' | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ion-grid [fixed]="true">
                <ion-row
                  data-cy="manage-users-privacy-policy"
                  class="privacy-policy-message"
                >
                  <ion-col
                    data-cy="manage-users-privacy-policy-column"
                    size="12"
                  >
                    <div data-cy="manage-users-privacy-policy-text">
                      {{'i18n.manageUsers.privacyPolicyText' | translate}}
                      <a
                        href="https://www.usfoods.com/content/dam/usf/EC/R4/documents/privacy.html"
                        target="_blank"
                      >
                        {{'i18n.manageUsers.privacyPolicyLink' | translate}}
                      </a>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </cdk-virtual-scroll-viewport>
          </div>
        </ng-container>

        <!-- START TABLET -->
        <ng-container
          *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
        >
          <div class="manage-users-list-section-desktop-container">
            <cdk-virtual-scroll-viewport
              class="virtual-scroll-viewport"
              [itemSize]="50"
              [minBufferPx]="400"
              [maxBufferPx]="800"
            >
              <app-sortable-section-desktop-tablet
                [sectionHeaders]="tabletHeaders"
                [selectedHeader]="selectedHeader"
                [hasSectionData]="true"
                [noDataText]="noUsersMessage | translate"
                (updateSortEventEmitter)="updateFilteredUserList($event)"
                [darkHeaders]="true"
              >
                <div *ngIf="(displayedUserList$ | async) as displayedUserList">
                  <div
                    *cdkVirtualFor="let user of displayedUserList; trackBy: trackByUserId"
                    class="sortable-section-data-row"
                  >
                    <app-manage-users-list-section-tablet
                      [user]="user"
                      [selectedHeader]="selectedHeader"
                      [currentUserId]="currentUserId"
                      (updateSort)="updateFilteredUserList($event)"
                      (openActionSheet)="openUserActionsHandler($event)"
                      (openExtendedView)="openUserExtendedView($event)"
                    >
                    </app-manage-users-list-section-tablet>
                  </div>
                </div>
              </app-sortable-section-desktop-tablet>

              <ng-container
                *ngIf="(customerUsers$ | async)?.length === 0 && (customerUsersCallComplete$ | async)"
              >
                <div class="empty-page-no-users-state-container">
                  <div class="empty-page-no-users-state-content">
                    <img
                      data-cy="'manage-users-empty-page-state'"
                      class="empty-page-image"
                      src="assets/images/chef-hat.svg"
                    />
                    <div class="no-users-message-container">
                      <span class="no-users-message">
                        {{ 'i18n.manageUsers.noUsers' | translate }}
                      </span>

                      <span>
                        {{ (currentCustomer$ | async)?.customerName }} ({{
                        (currentCustomer$ | async)?.customerNumber }})
                        <ng-container *ngIf="!!(currentDepartment$ | async)">
                          {{ (currentDepartment$ | async)?.departmentName }} ({{
                          (currentDepartment$ | async)?.departmentNumber }})
                        </ng-container>
                      </span>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container
                *ngIf="(customerUsers$ | async)?.length > 0 && (displayedUserList$ | async)?.length === 0"
              >
                <div class="empty-page-no-users-state-container">
                  <div class="empty-page-no-users-state-content">
                    <img
                      data-cy="'manage-users-empty-page-state'"
                      class="empty-page-image"
                      src="assets/images/chef-hat-with-search-icon.svg"
                    />
                    <div class="no-users-message-container">
                      <span class="no-users-message">
                        {{ ('i18n.manageUsers.noMatchesSearch' | translate: {
                        searchKey }) }}
                      </span>
                      <span>
                        {{ 'i18n.manageUsers.pleaseTryAgain' | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ion-grid [fixed]="true">
                <ion-row
                  data-cy="manage-users-privacy-policy"
                  class="privacy-policy-message"
                >
                  <ion-col
                    data-cy="manage-users-privacy-policy-column"
                    size="12"
                  >
                    <div data-cy="manage-users-privacy-policy-text">
                      {{'i18n.manageUsers.privacyPolicyText' | translate}}
                      <a
                        href="https://www.usfoods.com/content/dam/usf/EC/R4/documents/privacy.html"
                        target="_blank"
                      >
                        {{'i18n.manageUsers.privacyPolicyLink' | translate}}
                      </a>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </cdk-virtual-scroll-viewport>
          </div>
        </ng-container>

        <!-- Mobile View -->
        <ng-container
          *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
        >
          <div class="manage-users-list-section-mobile-container">
            <cdk-virtual-scroll-viewport
              class="virtual-scroll-viewport"
              [itemSize]="50"
              [minBufferPx]="400"
              [maxBufferPx]="800"
            >
              <app-sortable-section-desktop-tablet
                [sectionHeaders]="mobileHeaders"
                [selectedHeader]="selectedHeader"
                [hasSectionData]="true"
                [noDataText]="noUsersMessage | translate"
                (updateSortEventEmitter)="updateFilteredUserList($event)"
                [darkHeaders]="true"
              >
                <div *ngIf="(displayedUserList$ | async) as displayedUserList">
                  <div
                    *cdkVirtualFor="let user of displayedUserList; trackBy: trackByUserId"
                    class="sortable-section-data-row"
                  >
                    <app-manage-users-list-section-mobile
                      [user]="user"
                      [selectedHeader]="selectedHeader"
                      [currentUserId]="currentUserId"
                      (updateSort)="updateFilteredUserList($event)"
                      (openActionSheet)="openUserActionsHandler($event)"
                      (openExtendedView)="openUserExtendedView($event)"
                    >
                    </app-manage-users-list-section-mobile>
                  </div>
                </div>
              </app-sortable-section-desktop-tablet>

              <ng-container
                *ngIf="(customerUsers$ | async)?.length === 0  && (customerUsersCallComplete$ | async)"
              >
                <div class="empty-page-no-users-state-container">
                  <div class="empty-page-no-users-state-content">
                    <img
                      data-cy="'manage-users-empty-page-state'"
                      class="empty-page-image"
                      src="assets/images/chef-hat.svg"
                    />
                    <div class="no-users-message-container">
                      <span class="no-users-message">
                        {{'i18n.manageUsers.noUsers' | translate}}
                      </span>

                      <span>
                        {{(currentCustomer$ | async)?.customerName}}
                        ({{(currentCustomer$ | async)?.customerNumber}})
                        <ng-container *ngIf="!!(currentDepartment$ | async)">
                          {{(currentDepartment$ | async)?.departmentName}}
                          ({{(currentDepartment$ | async)?.departmentNumber}})
                        </ng-container>
                      </span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container
                *ngIf="(customerUsers$ | async)?.length > 0 && (displayedUserList$ | async)?.length === 0"
              >
                <div class="empty-page-no-users-state-container">
                  <div class="empty-page-no-users-state-content">
                    <img
                      data-cy="'manage-users-empty-page-state'"
                      class="empty-page-image"
                      src="assets/images/chef-hat-with-search-icon.svg"
                    />
                    <div class="no-users-message-container">
                      <span class="no-users-message">
                        {{ ('i18n.manageUsers.noMatchesSearch' | translate: {
                        searchKey }) }}
                      </span>
                      <span>
                        {{ 'i18n.manageUsers.pleaseTryAgain' | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ion-grid [fixed]="true">
                <ion-row
                  data-cy="manage-users-privacy-policy"
                  class="privacy-policy-message"
                >
                  <ion-col
                    data-cy="manage-users-privacy-policy-column"
                    size="12"
                  >
                    <div data-cy="manage-users-privacy-policy-text">
                      {{'i18n.manageUsers.privacyPolicyText' | translate}}
                      <a
                        href="https://www.usfoods.com/content/dam/usf/EC/R4/documents/privacy.html"
                        target="_blank"
                      >
                        {{'i18n.manageUsers.privacyPolicyLink' | translate}}
                      </a>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </cdk-virtual-scroll-viewport>
          </div>
        </ng-container>
        <!-- END MOBILE -->
      </ion-grid>
    </div>
  </div>
</ion-content>
